module.exports = __webpack_public_path__ + "img/handelsverband-mitglied.7aac21d.avif";